import React, { useEffect } from "react";
import WebData from "../../Helpers/WebData";
import "./Testimonials.style.css";

const Testmonials = () => {
  useEffect(() => {
    var testimContent = Array.prototype.slice.call(
        document.getElementById("testim-content").children
      ),
      testimSpeed = 6000,
      currentActive = 0,
      testimTimer,
      currentSlide = 0;

    window.onload = function () {
      // Testim Script
      playSlide(currentSlide);
    };

    function playSlide(slide) {
      for (var k = 0; k < testimContent.length; k++) {
        testimContent[k].classList.remove("active");
        testimContent[k].classList.remove("inactive");
      }

      if (slide < 0) {
        slide = currentSlide = testimContent.length - 1;
      }

      if (slide > testimContent.length - 1) {
        slide = currentSlide = 0;
      }

      if (currentActive !== currentSlide) {
        testimContent[currentActive].classList.add("inactive");
      }
      testimContent[slide].classList.add("active");

      currentActive = currentSlide;
      clearInterval(testimTimer);
      testimTimer = setInterval(function () {
        playSlide((currentSlide += 1));
      }, testimSpeed);
    }
  }, []);

  return (
    <>
      <section id="testimonials" className="py-4 testimonials">
        <div className="container">
          <h3 className="text-center global-heading mb-3">Testimonials</h3>
          <div id="testim-content" className="cont">
            <div className="active">
              <div className="image">
                <img src={WebData.personAvatar} alt="" />
                <h2>Ekaterina Sidorova</h2>
                <h2>Novosibrisk, Russia</h2>
                <p>
                  Came here for the sun, backwaters and Ayurveda. Got that and
                  more. Samskrithi is an excellent volunteer opportunity.
                </p>
              </div>
            </div>
            <div>
              <div className="image">
                <img src={WebData.personAvatar} alt="" />
                <h2>Debroy Chattopadhyay</h2>
                <h2>Burdwan, West Bengal</h2>
                <p>
                  Chanced upon SG riding during our bike tour. SG has a clear
                  sense on how and why to preserve indigenous cattle. Excellent
                  chyawanprash and ghee.
                </p>
              </div>
            </div>
            <div>
              <div className="image">
                <img src={WebData.personAvatar} alt="" />
                <h2>Anthony Rodriques</h2>
                <h2>Mapusa, Goa</h2>
                <p>
                  Mr. Jayan and his family loves cows. It is infectious! Try out
                  their Satvik store - you will find something for your kitchen.
                </p>
              </div>
            </div>
            <div>
              <div className="image">
                <img src={WebData.personAvatar} alt="" />
                <h2>Stanzin Chospel</h2>
                <h2>Marselang, Ladakh</h2>
                <p>
                  The goshala is located close to beaches, coconut farms and an
                  elephant camp. The effort they make to serve the animals is
                  astounding.
                </p>
              </div>
            </div>
            <div>
              <div className="image">
                <img src={WebData.personAvatar} alt="" />
                <h2>Vineeth Akkarakaran</h2>
                <h2>Doha, Qatar</h2>
                <p>
                  SG was recommended for our corporate donations. They send us
                  regular updates to about a Vechur bull and a Sahial calf we
                  adopted.
                </p>
              </div>
            </div>
            <div>
              <div className="image">
                <img src={WebData.personAvatar} alt="" />
                <h2>Akshata Malhar</h2>
                <h2>Beed, Maharashtra</h2>
                <p>
                  I was here to learn sustainable cattle rearing. Krishnalal ji
                  is an expert in making many products from milk, cow dung and
                  urine.
                </p>
              </div>
            </div>
            <div>
              <div className="image">
                <img src={WebData.personAvatar} alt="" />
                <h2>Abdul Qayyoom</h2>
                <h2>Bandipora, Jammu & Kashmir</h2>
                <p>
                  I spent a week at SG to learn to make traditional Ayurvedic
                  ghee and organic fertilizer. Very courteous and kind family
                  that keeps Indian traditions alive.
                </p>
              </div>
            </div>
            <>
              <div className="image">
                <img src={WebData.personAvatar} alt="" />
                <h2>Yew Soon Lee</h2>
                <h2>Singapore</h2>
                <p>
                  I chanced upon their website searching for Kerala beaches.
                  Lockdown struck and I couldn't make the trip but decided to
                  help them with social media marketing. Cows are Cool!
                </p>
              </div>
            </>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testmonials;
